import { inject } from 'mobx-react';
import * as React from 'react';
import { Comment } from '../../Models/Comment';
import { ApplicationStore } from '../../_stores/ApplicationStore';
import { CommentTreeRow } from './CommentTreeRow';

interface IProps {
    comments: Array<Comment>;
    store?: ApplicationStore;
}

@inject('store')
export class CommentTree extends React.Component<IProps> {

    public render() {
        return (
            <div style={styles.scroll} className="customScrollBar">
                {this.props.comments.map((comment, index) => {
                    return <CommentTreeRow key={comment.id} comment={comment} index={index}
                    />;
                })}
                <div style={styles.bottomPadding} />
            </div>
        );
    }
}

const styles = {
    scroll: {
        overflowY: 'scroll',
        overflowX: 'hidden',
        flex: '1 1 9em'
    } as React.CSSProperties,
    bottomPadding: {
        height: 300
    }
};



// WEBPACK FOOTER //
// ./src/Pages/PhotoViewer/CommentTree.tsx